import { AxiosError } from 'axios'
import { convertData, convertSystemData, ErrorMsgState } from '@/model/components/common/message/errorMessage'
import ERROR_CODE from '@/model/api/error/errorCodeType'
import { ErrorResponse } from './erroResponse'

/**
 * APIエラー処理関数の取得
 * @returns APIエラー処理関数を返す
 */
const useApiError = () => {
  /**
   * axiosのエラーレスポンスをエラー情報に設定する
   * @param e エラーインスタンス
   * @param state エラー情報
   */
  const setbaseError = async (e: AxiosError<ErrorResponse>, state: ErrorMsgState) => {
    // エラーメッセージを設定する
    await convertData(e, state, false)
  }
  /**
   * axiosのエラーレスポンスをエラー情報に設定する(キー紐付け変換をする)
   * @param e エラーインスタンス
   * @param state エラー情報
   */
  const setbaseLinkingError = async (e: AxiosError<ErrorResponse>, state: ErrorMsgState) => {
    // エラーメッセージを設定する
    await convertData(e, state, true)
  }
  /**
   * システムエラーをエラー情報に設定する
   * @param state エラー情報
   */
  const setsystemError = (state: ErrorMsgState): void => {
    // システムエラーメッセージを設定する
    convertSystemData(state)
  }

  /**
   * ダウンロードデータ無しであるか判定する
   * @param state エラー情報
   * @returns true:ダウンロードデータ無しエラー false:ダウンロードデータ無しエラー以外
   */
  const isDownloadNodata = (state: ErrorMsgState): boolean =>
    state.data.some((p) => p.code === ERROR_CODE.DOWNLOAD.NODATA.code)

  return {
    setbaseError, //
    setsystemError, //
    setbaseLinkingError,
    isDownloadNodata,
  }
}

export { useApiError }
